import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from '../components/AdminLayout';
import { apiFetch } from '../api';
import { PageHeader, ui } from '../components/adminUi';

const SEGMENTS = [
  { value: 'all', label: 'Barcha foydalanuvchilar' },
  { value: 'clients', label: 'Faqat mijozlar' },
  { value: 'providers', label: 'Faqat ustalar' },
];

export default function NotificationsPage() {
  const { auth } = useAuth();

  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [segment, setSegment] = useState('all');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const send = async () => {
    setError('');
    setResult(null);
    if (!title.trim() && !message.trim()) {
      setError('Sarlavha yoki matn majburiy');
      return;
    }
    setSending(true);
    try {
      const res = await apiFetch('/api/admin/notifications/push', auth.token, {
        method: 'POST',
        body: JSON.stringify({
          title: title.trim(),
          message: message.trim(),
          segment,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.message || 'Yuborishda xatolik yuz berdi.');
        return;
      }
      const count = data.recipientsCount ?? data.recipients_count;
      setResult(count != null
        ? `Xabar yuborildi — ${count} ta foydalanuvchiga yetkazildi.`
        : 'Xabar muvaffaqiyatli yuborildi.');
      setTitle('');
      setMessage('');
    } catch {
      setError('Tarmoq xatosi. Qayta urinib ko\'ring.');
    } finally {
      setSending(false);
    }
  };

  return (
    <AdminLayout>
      <PageHeader title="Push xabar yuborish" subtitle="Foydalanuvchilarga bildirishnoma jo'nating" />

      <div style={s.card}>
        <div style={ui.field}>
          <label style={ui.label}>Sarlavha</label>
          <input
            style={ui.input}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Xabar sarlavhasi"
            disabled={sending}
            maxLength={120}
          />
        </div>

        <div style={ui.field}>
          <label style={ui.label}>Matn</label>
          <textarea
            style={ui.textarea}
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Xabar matni"
            disabled={sending}
          />
        </div>

        <div style={ui.field}>
          <label style={ui.label}>Segment</label>
          <div style={s.segRow}>
            {SEGMENTS.map((seg) => {
              const active = segment === seg.value;
              return (
                <button
                  key={seg.value}
                  type="button"
                  onClick={() => setSegment(seg.value)}
                  style={{ ...s.segBtn, ...(active ? s.segBtnActive : {}) }}
                  disabled={sending}
                >
                  {seg.label}
                </button>
              );
            })}
          </div>
        </div>

        {error && <div style={ui.formError}>{error}</div>}
        {result && <div style={s.success}>{result}</div>}

        <div style={{ ...ui.modalActions, marginTop: '16px' }}>
          <button
            style={{ ...ui.saveBtn, ...(sending ? ui.btnDisabled : {}) }}
            onClick={send}
            disabled={sending}
          >
            {sending ? 'Yuborilmoqda...' : '🔔 Yuborish'}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}

const s = {
  card: {
    background: 'var(--surface)',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    maxWidth: '620px',
  },
  segRow: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
  segBtn: {
    padding: '9px 16px',
    background: 'var(--bg)',
    color: 'var(--text-secondary)',
    border: '1.5px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  segBtnActive: {
    background: '#fdf2f4',
    color: 'var(--brand)',
    borderColor: 'var(--brand)',
  },
  success: {
    background: 'var(--success-tint)',
    border: '1px solid #bbf7d0',
    borderRadius: '8px',
    padding: '12px 14px',
    color: 'var(--success)',
    fontSize: '14px',
    marginTop: '4px',
  },
};
